import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { products_uri } from "../../utils/url";
import { POST } from "../../utils/requests";
import { toast } from "react-toastify";
import { PRICE_TYPE } from "../../utils/types";
import { Checkbox } from "antd";

export default function ProductAdd({callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [data, setData] = useState({name:'', price:'', price_many:''});
  const [isPriceMany, setIsPriceMany] = useState(false);

  const handlecal = () => {
    callback();
  }

  const Cancel = () => {
    onOpenChange(false);
  };

  const Submit = async () => {
    setLoad(true)
    const b = await POST({uri:products_uri +'/create', data: data});
    toast.success("Амжилттай нэмлээ");
    handlecal();
    setIsPriceMany(false);
    setData({...data, name: "", price: "", price_many: ""});
    setLoad(false);
    Cancel();
  };

  const handlePriceCheck = (e) => {
    setIsPriceMany(e.target.checked);
    setData({ ...data, price_many: e.target.checked ? PRICE_TYPE.Y : "" });
  };

  return (
    <>
      <Button size="sm" className="bg-green-600 text-white" onPress={onOpen}>Бараа нэмэх</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="2xl">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Бараа нэмэх</ModalHeader>
              <ModalBody>
                <div className="h-4/3">
                  <h1 className="font-Roboto text-sm font-bold">Барааны нэр оруулах</h1>
                  <Input size="sm" className="mt-1" placeholder="Нэр оруулах"  onChange={(e)=> setData({...data, name: e.target.value})}/>

                  <Checkbox className="mt-4" checked={isPriceMany} onChange={handlePriceCheck}>
                    Олон үнэтэй эсэх
                  </Checkbox>

                  {/* {
                    isPriceMany ?
                    <div className="bg-green-400 rounded-md p-2 mt-2">
                      <h1>Үнэ оруулах *</h1>
                      <Input type="number" size="sm" className="mt-1" placeholder="Үнэ оруулах" value={price} onChange={(e)=> setPrice(e.target.value)}/>
                      <Button className="mt-2 w-full bg-blue-600 text-white">Нэмэх</Button>
                    </div>
                    :
                    <>
                      <h1 className="font-Roboto text-sm font-bold mt-4">Барааны үнэ оруулах</h1>
                      <Input type="number" size="sm" className="mt-1" placeholder="Үнэ оруулах" onChange={(e)=> setData({...data, price: e.target.value})}/>
                    </>
                  } */}
                  <>
                    <h1 className="font-Roboto text-sm font-bold mt-4">Барааны үнэ оруулах</h1>
                    <Input type="number" size="sm" className="mt-1" placeholder="Үнэ оруулах" onChange={(e)=> setData({...data, price: e.target.value})}/>
                  </>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={Cancel}>
                  Болих
                </Button>
                {
                  load?
                  <Button color="primary">
                    Уншиж байна ... <Spinner/>
                  </Button>
                  :
                  <Button color="primary" onPress={Submit}>
                    Нэмэх
                  </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}